import logger from "../../utils/logger";
import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { createCompany } from "../../slices/apps/companySlice";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// react select
import Select from "react-select";
const getSelectStyles = (validation, fieldName) => ({
  control: (base, state) => ({
    ...base,
    borderColor:
      validation.touched[fieldName] && validation.errors[fieldName]
        ? "#e30a17"
        : state.isFocused
          ? "#80bdff"
          : "#e9ebec",
  }),
  placeholder: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  }),
});

// react input mask
import { IMaskInput } from "react-imask";
import { NumericFormat } from "react-number-format";

// data dosyaları
import CityJson from "../../common/il.json";

const cities = CityJson.map((data) => ({
  label: data.il_adi,
  value: data.il_adi,
  districts: data.ilceler
    .map((ilce) => ({
      label: ilce.ilce_adi,
      value: ilce.ilce_adi,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)),
})).sort((a, b) => a.label.localeCompare(b.label));

const companyTypeOptions = [
  { value: 0, label: "Şahıs Şirketi" },
  { value: 1, label: "Firma (LTD, A.Ş. vb.)" },
];

const AddModal = () => {
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [districts, setDistricts] = useState([]);

  const { createCompanyLoading } = useSelector((state) => {
    return {
      createCompanyLoading: state.company?.createCompanyLoading || false,
    };
  }, shallowEqual);

  function toggle_modal(e) {
    if (e) {
      validation.resetForm();

      setModal(true);
    } else {
      setModal(false);
    }
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      companyName: "",
      companyTableName: "",

      authName: "",
      authSurname: "",
      companyType: "",
      taxOffice: "",
      taxNumber: "",
      city: "",
      state: "",
      address: "",
      phoneNumber: "",
      email: "",

      primTriggerPercent: "",
      primAmount: "",
      commissionFee: "",
    },

    validationSchema: Yup.object({
      companyName: Yup.string()
        .max(150, "Firma adı en fazla 150 karakter olabilir.")
        .required("Lütfen firma adını giriniz."),
      companyTableName: Yup.string()
        .max(150, "Tabela adı en fazla 150 karakter olabilir.")
        .required("Lütfen tabela adını giriniz."),
      authName: Yup.string()
        .max(50, "Yetkili adı en fazla 50 karakter olabilir.")
        .required("Lütfen yetkili adını giriniz."),
      authSurname: Yup.string()
        .max(50, "Yetkili soyadı en fazla 50 karakter olabilir.")
        .required("Lütfen yetkili soyadını giriniz."),
      companyType: Yup.number().required("Lütfen firma tipini seçiniz."),
      taxOffice: Yup.string()
        .max(100, "Vergi dairesi en fazla 100 karakter olabilir.")
        .required("Lütfen vergi dairesini giriniz."),
      taxNumber: Yup.string()
        .min(10, "TC/Vergi numarası en az 10 karakter olmalıdır.")
        .max(11, "TC/Vergi numarası en fazla 11 karakter olabilir.")
        .required("Lütfen Vergi / T.C. Kimlik numarasını giriniz."),
      city: Yup.string()
        .max(50, "İl en fazla 50 karakter olabilir.")
        .required("Lütfen il seçiniz."),
      state: Yup.string()
        .max(50, "İlçe en fazla 50 karakter olabilir.")
        .required("Lütfen ilçe seçiniz."),
      address: Yup.string()
        .max(250, "Adres en fazla 250 karakter olabilir.")
        .required("Lütfen adres giriniz."),
      phoneNumber: Yup.string()
        .max(20, "Telefon numarası en fazla 20 karakter olabilir.")
        .required("Lütfen telefon numarası giriniz."),
      email: Yup.string()
        .email("Lütfen geçerli bir e-posta adresi giriniz.")
        .max(100, "E-posta en fazla 100 karakter olabilir.")
        .required("Lütfen e-posta adresi giriniz."),
      primTriggerPercent: Yup.number()
        .min(0.1, "Komisyon oranı en az 0.1 olabilir.")
        .max(100, "Komisyon oranı en fazla 100 olabilir.")
        .required("Lütfen komisyon oranını giriniz."),
      primAmount: Yup.number()
        .positive("Prim ücreti pozitif bir değer olmalıdır.")
        .required("Lütfen prim ücretini giriniz."),
      commissionFee: Yup.number()
        .positive("Ciro prim ücreti pozitif bir değer olmalıdır.")
        .required("Lütfen ciro prim ücretini giriniz."),
    }),

    onSubmit: async (values) => {
      try {
        await dispatch(createCompany(values)).unwrap();
        setModal(false);
      } catch (error) {
        logger.error("Firma kaydı başarısız:", error);
      }
    },
  });

  useEffect(() => {
    if (validation.values.city) {
      const selectedCity = cities.find(
        (c) => c.value === validation.values.city
      );
      setDistricts(selectedCity ? selectedCity.districts : []);
    } else {
      setDistricts([]);
    }
  }, [validation.values.city]);

  const blockInvalidChars = (e) => {
    const blockedKeys = ["-", "e", "+", "E"];

    if (blockedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Fragment>
      <Button
        className="btn btn-label btn"
        color="primary"
        type="button"
        onClick={() => toggle_modal(true)}
      >
        <i className="ri-add-line label-icon align-middle me-2"></i>
        Firma Oluştur
      </Button>

      <Modal
        size="xl"
        isOpen={modal}
        toggle={() => {
          toggle_modal(false);
        }}
        centered
      >
        <ModalHeader
          className="modal-title"
          id="myLargeModalLabel"
          toggle={() => {
            toggle_modal(false);
          }}
        >
          Firma Oluştur
        </ModalHeader>

        <ModalBody className="p-4">
          <Form onSubmit={validation.handleSubmit} autoComplete="off">
            <Row className="gy-3">
              <Col lg={6}>
                <Label>Firma Adı</Label>
                <Input
                  type="text"
                  name="companyName"
                  placeholder="Örnek A.Ş."
                  maxLength={150}
                  value={validation.values.companyName}
                  onChange={validation.handleChange}
                  invalid={
                    !!(
                      validation.touched.companyName &&
                      validation.errors.companyName
                    )
                  }
                />
                <FormFeedback>{validation.errors.companyName}</FormFeedback>
              </Col>

              <Col lg={6}>
                <Label>Tabela Adı</Label>
                <Input
                  type="text"
                  name="companyTableName"
                  placeholder="Örnek Manav"
                  maxLength={150}
                  value={validation.values.companyTableName}
                  onChange={validation.handleChange}
                  invalid={
                    !!(
                      validation.touched.companyTableName &&
                      validation.errors.companyTableName
                    )
                  }
                />
                {validation.touched.companyTableName &&
                  validation.errors.companyTableName && (
                    <div className="invalid-feedback d-block">
                      {validation.errors.companyTableName}
                    </div>
                  )}
              </Col>

              <Col lg={6}>
                <Label>Firma Tipi</Label>
                <Select
                  name="companyType"
                  placeholder="Seçiniz..."
                  options={companyTypeOptions}
                  menuPlacement="auto"
                  value={
                    companyTypeOptions.find(
                      (opt) => opt.value === validation.values.companyType
                    ) || null
                  }
                  onChange={(option) =>
                    validation.setFieldValue(
                      "companyType",
                      option ? option.value : ""
                    )
                  }
                  styles={getSelectStyles(validation, "companyType")}
                />
                {validation.touched.companyType &&
                  validation.errors.companyType && (
                    <div className="invalid-feedback d-block">
                      {validation.errors.companyType}
                    </div>
                  )}
              </Col>

              <div className="w-100 p-0 m-0"></div>

              <Col lg={6}>
                <Label>Yetkili Adı</Label>
                <Input
                  type="text"
                  name="authName"
                  placeholder="Can"
                  maxLength={50}
                  value={validation.values.authName}
                  onChange={validation.handleChange}
                  invalid={
                    !!(
                      validation.touched.authName && validation.errors.authName
                    )
                  }
                />
                <FormFeedback>{validation.errors.authName}</FormFeedback>
              </Col>

              <Col lg={6}>
                <Label>Yetkili Soyadı</Label>
                <Input
                  type="text"
                  name="authSurname"
                  placeholder="Yılmaz"
                  maxLength={50}
                  value={validation.values.authSurname}
                  onChange={validation.handleChange}
                  invalid={
                    !!(
                      validation.touched.authSurname &&
                      validation.errors.authSurname
                    )
                  }
                />
                <FormFeedback>{validation.errors.authSurname}</FormFeedback>
              </Col>

              <Col lg={6}>
                <Label>Vergi Dairesi</Label>
                <Input
                  type="text"
                  name="taxOffice"
                  placeholder="Maslak Vergi Dairesi"
                  maxLength={100}
                  value={validation.values.taxOffice}
                  onChange={validation.handleChange}
                  invalid={
                    !!(
                      validation.touched.taxOffice &&
                      validation.errors.taxOffice
                    )
                  }
                />
                <FormFeedback>{validation.errors.taxOffice}</FormFeedback>
              </Col>

              <Col lg={6}>
                <Label>Vergi / T.C. Kimlik Numarası</Label>
                <IMaskInput
                  inputMode="numeric"
                  mask="0000000000[0]"
                  unmask={true}
                  name="taxNumber"
                  placeholder="11 haneli TC veya 10 haneli VKN"
                  value={validation.values.taxNumber}
                  onAccept={(value) => {
                    validation.setFieldValue("taxNumber", value);
                  }}
                  onBlur={validation.handleBlur}
                  className={`form-control ${validation.touched.taxNumber && validation.errors.taxNumber
                      ? "is-invalid"
                      : ""
                    }`}
                />
                {validation.touched.taxNumber &&
                  validation.errors.taxNumber && (
                    <div className="invalid-feedback d-block">
                      {validation.errors.taxNumber}
                    </div>
                  )}
              </Col>

              <Col lg={6}>
                <Label>E-posta Adresi</Label>
                <Input
                  type="email"
                  name="email"
                  placeholder="firma@ornek.com"
                  maxLength={100}
                  value={validation.values.email}
                  onChange={validation.handleChange}
                  invalid={
                    !!(validation.touched.email && validation.errors.email)
                  }
                />
                <FormFeedback>{validation.errors.email}</FormFeedback>
              </Col>

              <Col lg={6}>
                <Label>Telefon Numarası</Label>
                <InputGroup>
                  <span
                    className="input-group-text"
                    style={{
                      width: "44px",
                      justifyContent: "center",
                    }}
                  >
                    0
                  </span>
                  <IMaskInput
                    inputMode="numeric"
                    mask="000 000 00 00"
                    unmask={true}
                    name="phoneNumber"
                    placeholder="5XX XXX XX XX"
                    value={validation.values.phoneNumber}
                    className={`form-control ${validation.touched.phoneNumber &&
                        validation.errors.phoneNumber
                        ? "is-invalid"
                        : ""
                      }`}
                    style={{ zIndex: 0 }}
                    onAccept={(value) =>
                      validation.setFieldValue("phoneNumber", value)
                    }
                  />
                </InputGroup>
                {validation.touched.phoneNumber &&
                  validation.errors.phoneNumber && (
                    <div className="invalid-feedback d-block">
                      {validation.errors.phoneNumber}
                    </div>
                  )}
              </Col>

              <Col lg={6}>
                <Label>Dönüşüm Oranı Alt Limit</Label>
                <InputGroup>
                  <span className="input-group-text">%</span>

                  <NumericFormat
                    className={`form-control ${validation.touched.primTriggerPercent &&
                        validation.errors.primTriggerPercent
                        ? "is-invalid"
                        : ""
                      }`}
                    value={validation.values.primTriggerPercent}
                    placeholder="0 ile 100 arası (Örn: 5,78)"
                    decimalSeparator=","
                    allowedDecimalSeparators={["."]}
                    decimalScale={2}
                    fixedDecimalScale={false}
                    allowNegative={false}
                    isAllowed={(values) => {
                      const { floatValue } = values;
                      return (
                        floatValue === undefined ||
                        (floatValue >= 0 && floatValue <= 100)
                      );
                    }}
                    onValueChange={(values) => {
                      validation.setFieldValue(
                        "primTriggerPercent",
                        values.value
                      );
                    }}
                  />

                  {validation.touched.primTriggerPercent &&
                    validation.errors.primTriggerPercent && (
                      <div className="invalid-feedback d-block">
                        {validation.errors.primTriggerPercent}
                      </div>
                    )}
                </InputGroup>
              </Col>

              <Col lg={6}>
                <Label>QR Prim Ücreti</Label>
                <InputGroup>
                  <span className="input-group-text">₺</span>
                  <Input
                    type="number"
                    name="primAmount"
                    placeholder="1500"
                    value={validation.values.primAmount}
                    onChange={(e) => {
                      const value = e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1");
                      validation.setFieldValue("primAmount", value);
                    }}
                    onKeyDown={blockInvalidChars}
                    invalid={
                      !!(
                        validation.touched.primAmount &&
                        validation.errors.primAmount
                      )
                    }
                  />
                </InputGroup>
                {validation.touched.primAmount &&
                  validation.errors.primAmount && (
                    <div className="invalid-feedback d-block">
                      {validation.errors.primAmount}
                    </div>
                  )}
              </Col>

              <Col lg={6}>
                <Label>Ciro Prim Ücreti</Label>
                <InputGroup>
                  <span className="input-group-text">₺</span>
                  <Input
                    type="number"
                    name="commissionFee"
                    placeholder="1500"
                    value={validation.values.commissionFee}
                    onChange={(e) => {
                      const value = e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1");
                      validation.setFieldValue("commissionFee", value);
                    }}
                    onKeyDown={blockInvalidChars}
                    invalid={
                      !!(
                        validation.touched.commissionFee &&
                        validation.errors.commissionFee
                      )
                    }
                  />
                </InputGroup>
                {validation.touched.commissionFee &&
                  validation.errors.commissionFee && (
                    <div className="invalid-feedback d-block">
                      {validation.errors.commissionFee}
                    </div>
                  )}
              </Col>

              <div className="w-100 p-0 m-0"></div>

              <Col lg={6}>
                <Label>İl</Label>
                <Select
                  name="city"
                  placeholder="İl Seçiniz"
                  isClearable
                  options={cities}
                  menuPlacement="auto"
                  value={
                    cities.find(
                      (item) => item.value === validation.values.city
                    ) || null
                  }
                  onChange={(event) =>
                    validation.setFieldValue("city", event ? event.value : "")
                  }
                  styles={getSelectStyles(validation, "city")}
                />
                {validation.touched.city && validation.errors.city && (
                  <div className="invalid-feedback d-block">
                    {validation.errors.city}
                  </div>
                )}
              </Col>

              <Col lg={6}>
                <Label>İlçe</Label>
                <Select
                  name="state"
                  placeholder="İlçe Seçiniz"
                  isClearable
                  options={districts}
                  menuPlacement="auto"
                  value={
                    districts.find(
                      (item) => item.value === validation.values.state
                    ) || null
                  }
                  onChange={(event) =>
                    validation.setFieldValue("state", event ? event.value : "")
                  }
                  styles={getSelectStyles(validation, "state")}
                  isDisabled={!validation.values.city}
                />
                {validation.touched.state && validation.errors.state && (
                  <div className="invalid-feedback d-block">
                    {validation.errors.state}
                  </div>
                )}
              </Col>

              <Col lg={12}>
                <Label>Adres</Label>
                <Input
                  type="textarea"
                  name="address"
                  rows="3"
                  placeholder="Firma adresi"
                  maxLength={250}
                  style={{ resize: "none" }}
                  value={validation.values.address}
                  onChange={validation.handleChange}
                  invalid={
                    !!(validation.touched.address && validation.errors.address)
                  }
                />
                <FormFeedback>{validation.errors.address}</FormFeedback>
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                type="button"
                color="primary"
                onClick={() => validation.handleSubmit()}
                className="btn btn-label"
                disabled={createCompanyLoading}
              >
                <i className="ri-check-line label-icon align-middle me-2"></i>{" "}
                Oluştur
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default AddModal;
